import { object, string } from 'yup';

export const IAddressSchema = object({
  street: string().required().trim(),
  number: string()
    .trim()
    .required()
    .matches(/^\d+(\s?\w+)?$/),
  zipCode: string()
    .trim()
    .required()
    .matches(/^\d{5}$/),
  city: string().trim().required(),
});

export type IAddress = {
  street: string;
  number: string;
  zipCode: string;
  city: string;
};
